// config is a map between format id and a function
export default {
  'auto-cut-cc-150': require('./auto-cut-cc-150'),
  'auto-cut-cc-150-10UP-landscape': require('./auto-cut-cc-150-10UP-landscape'),
  'ricordino-148x100-d500-d1000': require('./ricordino-148x100-d500-d1000'),
  'ricordino-130x180': require('./ricordino-130x180'),
  'ricordino-57x88': require('./ricordino-57x88'),
};
